/**
 * Low-level fetch wrappers for the /auth-api/* contract.
 *
 * Thin layer — no retry, no caching, no React. React Query hooks in
 * queries.ts wrap these for the app layer.
 *
 * All endpoints resolve relative to `window.location.origin` — nginx
 * handles the /auth-api/ → /api/ rewrite for us server-side. During
 * Vite dev, the Vite proxy in the app's vite.config.ts must apply the
 * same rewrite: `rewrite: (p) => p.replace(/^\/auth-api/, '/api')`.
 */
import { withSilentRefresh } from './silentRefresh';
const AUTH_API_BASE = '/auth-api';
// AWSDO-1316: silent-refresh interceptor. Wraps the global fetch so a
// 401 from any /auth-api/* call triggers a single transparent refresh
// + retry before bubbling the error. Concurrent 401s share the in-flight
// refresh promise (see silentRefresh.ts for the dedup logic).
const refreshAwareFetch = withSilentRefresh(fetch);
export class AuthApiError extends Error {
    status;
    payload;
    constructor(message, status, payload) {
        super(message);
        this.status = status;
        this.payload = payload;
        this.name = 'AuthApiError';
    }
}
async function jsonRequest(url, init) {
    const response = await refreshAwareFetch(url, {
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            ...(init?.headers ?? {}),
        },
        ...init,
    });
    let payload;
    try {
        payload = await response.json();
    }
    catch {
        payload = undefined;
    }
    if (!response.ok) {
        throw new AuthApiError(`auth-api ${response.status} ${response.statusText}`, response.status, payload);
    }
    return payload;
}
export function postLogin(request) {
    return jsonRequest(`${AUTH_API_BASE}/login`, {
        method: 'POST',
        body: JSON.stringify(request),
    });
}
//# sourceMappingURL=api.js.map